<template xmlns="http://www.w3.org/1999/html">
  <div class="uk-grid-medium add-update-auto-page" uk-grid>
    <div class="uk-width-5-5">
      <CompanyBreadcrumb
          :aria-label="isEditMode ? $t('general.edit_auto_assignment') : $t('general.new_auto_assignment')"
          :home-aria-label="$t('general.home')"
          :items="breadcrumbItems"
      />

      <div class="section-header mb-lg-2 border-0 uk-flex-middle">
        <div class="section-header-left">
          <h2 class="uk-heading-line text-left">
            <span>{{ isEditMode ? $t('general.edit_auto_assignment') : $t('general.new_auto_assignment') }}</span></h2>
        </div>
      </div>
      <div class="card">
        <ul id="uk-switcher-tab" class="uk-child-width-expand uk-tab stepper-buttons"
            uk-switcher="connect: #main-switcher-tabs ; animation: uk-animation-slide-left-medium, uk-animation-slide-right-medium">
          <li class="uk-active">
            <a class=" p-4 header-a" href="#"><i class="icon-feather-flag"></i> <b>{{ this.$t('login.header') }}</b></a>
          </li>
          <li>
            <a class="p-4 header-a" href="#"><i class="uil-book-open"></i> <b>{{ $t('general.rules') }}</b></a>
          </li>
        </ul>
        <div>
          <div class="card-body">
            <ul id="main-switcher-tabs" class="uk-switcher uk-margin">
              <!--tab: giris-->
              <li>
                <!--modal: atama secimi-->
                <AppModal :bottom-sheet="true"
                          :close-on-overlay="false"
                          :title="$t('general.registered_assignments')"
                          :visible.sync="showAssignmentModal"
                          max-height="90vh"
                          width="75%"
                >
                  <div class="assignment-modal-body">
                    <div class="modal-toolbar">
                      <search-input v-model="filter.assignmentSearch" :control-height="48" :debounce="0"
                                    :placeholder="$t('filters.search')"/>
                      <sort-dropdown :sort-options="assignmentSortOptions" @sort-selected="handleSortSelected"/>
                    </div>
                    <div class="table-responsive mt-3">
                      <table class="table align-items-center">
                        <thead>
                        <tr>
                          <th scope="col">{{ $t('general.assignment_name') }}</th>
                          <th scope="col">{{ $t('general.created_at') }}</th>
                        </tr>
                        </thead>
                        <tbody v-if="formattedItem" class="list">
                        <tr v-for="(item, index) in formattedItem">
                          <th scope="row">
                            <span class="name h6 mb-0 text-sm">{{ item.name }}</span>
                            <small class="d-block font-weight-bold"></small>
                          </th>
                          <td>{{ $t(item.created_at) }}</td>
                          <td class="text-right">
                            <div class="actions ml-3">
                              <template v-if="selectedAssignmentItems.includes(item.id)">
                                <button class="btn btn-sm btn-success" style="color: #fff"
                                        @click="removeAssignment(item)">
                                  <i class="uil-check"></i>
                                  {{ $t('general.added') }}
                                </button>
                              </template>
                              <template v-else>
                                <button class="btn btn-sm btn-primary" style="color: #fff"
                                        @click="addAssignment(item)">
                                  <i class="uil-plus"></i> {{ $t('general.add') }}
                                </button>
                              </template>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row">
                      <div class="col-12 text-center">
                        <pagination v-if="pagination && pagination.hasOwnProperty('links')" :pagination="pagination"
                                    @changePage="setPage($event, 'assignment')"></pagination>
                      </div>
                    </div>
                  </div>
                  <template #footer>
                    <button class="btn btn-sm btn-secondary" type="button"
                            @click="showAssignmentModal = false">
                      {{ $t('general.cancel') }}
                    </button>
                    <button :disabled="!selectedAssignmentItems[0]" class="btn btn-sm btn-primary"
                            style="color: #fff" @click="saveAssignment()">
                      {{ $t('general.save') }}
                    </button>
                  </template>
                </AppModal>
                <div>
                  <div class="col-xl-10 m-auto">
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="course_title">{{ $t('general.auto_assignment_name') }}
                        <span class="required">*</span></label>
                      <div class="col-md-9">
                        <input id="course_title" v-model="form.name" class="form-control" required="" type="text"/>
                      </div>
                    </div>
                    <div class="form-group row mb-3">
                      <div class="col-md-2">
                        <label class="col-form-label">
                          {{ $t('general.selected_assignment') }} <span class="required">*</span>
                        </label>
                      </div>
                      <div class="col-md-10">
                        <span v-if="selectedAssignmentName && form.assignment_id" class="mr-4"><b><i
                            class="uil-location-arrow"></i>{{
                            selectedAssignmentName
                          }}</b></span>
                        <span v-if="!form.assignment_id" class="mr-4"><b>{{
                            $t('general.please_select_assignment')
                          }}</b></span>
                        <button class="btn btn-default btn-icon-label" type="button"
                                @click="showAssignmentModal = true">
                          <span class="btn-inner--icon">
                            <i class="uil-location-arrow"></i>
                          </span>
                          <span class="btn-inner--text">
                            {{ $t('general.select_assignment') }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="uk-card-footer float-right pb-0 pr-0 mb-3">
                  <button :disabled="!form['assignment_id'] || !form.name" class="uk-button uk-button-primary small"
                          type="button" @click="validateAndSwitch(1)">
                    <i class="icon-feather-arrow-right"></i> {{ this.$t('general.save_and_continue') }}
                  </button>
                </div>
              </li>
              <!--tab: kurallar-->
              <li>
                <!--modal: kural secimi-->
                <AppModal :bottom-sheet="true"
                          :close-on-overlay="false"
                          :title="$t('general.rule_sets')"
                          :visible.sync="showRulesModal"
                          max-height="90vh"
                          width="75%"
                >
                  <div class="rules-modal-body">
                    <div class="mb-3">
                      <label class="col-form-label" for="rules_list">{{ $t('general.rule_set') }}<span
                          class="required">*</span></label>
                      <multiple-select-input v-model="selectedRule"
                                             :allowEmpty="false"
                                             :multiple="false"
                                             :required="false"
                                             :searchable="true"
                                             :showLabels="false"
                                             :values="selectedEvent ? ruleTypeEvents : ruleTypeStatus"
                                             label="name"
                                             trackBy="id"
                                             @select="changeOption('change')"
                      />
                    </div>
                    <div v-if="form.rules.length !== 0 && selectedRule && !selectedEvent">
                      <div class="mb-3">
                        <h6 class="mb-2">{{ selectedRule.name }}</h6>
                        <search-input v-model="filter.ruleSearch" :control-height="48" :debounce="0"
                                      :placeholder="$t('general.search')"/>
                      </div>
                      <div class="table-responsive">
                        <table class="table align-items-center">
                          <tbody v-if="ruleItems.length > 0" class="list">
                          <tr v-for="(item, index) in ruleItems">
                            <th scope="row">
                              <span class="name h6 mb-0 text-sm">{{ item.name }}</span>
                            </th>
                            <td class="text-right">
                              <div class="actions">
                                <template v-if="selectedRuleItems.some((e => e.id === item.id))">
                                  <button class="btn btn-sm btn-success" style="color: #fff"
                                          @click="removeRuleItem(item)">
                                    <i class="uil-check"></i>
                                    {{ $t('general.added') }}
                                  </button>
                                </template>
                                <template v-else>
                                  <button class="btn btn-sm btn-primary" style="color: #fff"
                                          @click="addRuleItem(item)">
                                    <i class="uil-plus"></i> {{ $t('general.add') }}
                                  </button>
                                </template>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <pagination v-if="pagination && pagination.hasOwnProperty('links')"
                                  :pagination="paginationRule" @changePage="setPage($event, 'rules')"></pagination>
                    </div>
                    <div class="mt-3">
                      <div class="uk-alert-access d-flex" uk-alert>
                        <i class="uil-comment-info-alt uk-text-success mr-3" style="font-size:2.4rem;"></i>
                        <p>{{ $t('general.rule_set_info') }}</p>
                      </div>
                    </div>
                  </div>
                  <template #footer>
                    <button class="btn btn-sm btn-secondary" type="button"
                            @click="showRulesModal = false">
                      {{ $t('general.cancel') }}
                    </button>
                    <button :disabled="form.rules.length > 0 && selectedRuleItems.length === 0"
                            class="btn btn-sm btn-primary"
                            style="color: #fff"
                            type="button" @click="saveRule()">
                      {{ $t("general.save") }}
                    </button>
                  </template>
                </AppModal>
                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-2 mx-2 px-2 pt-2 pb-3">
                      <ul class="rules_list">
                        <li>
                          <p class="lead text-center mb-1">{{ $t('general.if') }}</p>
                        </li>
                        <div v-if="form.rules.length !== 0" class="w-100 d-flex justify-content-between p-2"
                             style="background-color:#f8f8f8">
                          <div><b><i class="uil-bolt-alt" style="color:#666CFF"></i>{{ form.rules[0].name }}</b></div>
                          <div>
                            <button class="uk-button uk-button-link mr-2"
                                    @click="openRuleModal('ruleTypeEvents', 0, 'editRule')"><i class="uil-edit"></i>
                            </button>
                          </div>
                        </div>
                        <li v-if="form.rules.length === 0">
                          <button class="uk-button uk-button-primary uk-button-small w-100" type="button"
                                  @click="openRuleModal('ruleTypeEvents', 0, 'addRule')">
                            <i class="uil-bolt-alt"></i> {{ $t('general.add_rule') }}
                          </button>
                        </li>
                        <li>
                          <p class="lead text-center mt-1">{{ $t('general.if_auto_assign') }}</p>
                        </li>
                      </ul>
                      <ul v-for="(item, index) in form.rules" class="rules_list">
                        <li v-if="index !== 0">
                          <div class="rule-row row p-2">
                            <div class="rule-row__label"><b><i
                                class="uil-bolt-alt" style="color:#666CFF"></i>{{
                                item.name
                              }}:</b></div>
                            <div class="rule-row__values">
                              <b>
                                <span v-for="(subItem, index) in item.ruleable_names">{{
                                    subItem
                                  }}{{ item.ruleable_names.length - 1 !== index ? ', ' : ' ' }} </span> </b>
                            </div>
                            <div class="rule-row__actions">
                              <button class="uk-button uk-button-link mr-2"
                                      @click="openRuleModal('ruleTypeStatus', index, 'editRule')"><i
                                  class="uil-edit"></i></button>
                              <button class="uk-button uk-button-link uk-text-warning" @click="deleteRule(index)"><i
                                  class="uil-trash"></i></button>
                            </div>
                          </div>
                        </li>
                        <li>
                          <multiple-select-input :allowEmpty="false"
                                                 :maxHeight="80"
                                                 :model="operatorOptions.find(o => o.id === item.ruleable_operator)"
                                                 :multiple="false"
                                                 :searchable="false"
                                                 :showLabels="false"
                                                 :values="index !== 0 ? operatorOptions : operatorOptions.filter(o => o.id === 'and')"
                                                 label="name"
                                                 trackBy="id"
                                                 @select="val => item.ruleable_operator = val.id"
                          />
                        </li>
                        <li>
                          <p class="lead text-center mt-1">{{ $t('general.if_auto_assign') }}</p>
                        </li>

                      </ul>
                      <li v-if="form.rules.length !== 0">
                        <button class="uk-button uk-button-primary uk-button-small w-100" type="button"
                                @click="openRuleModal('ruleTypeStatus', form.rules.length, 'addRule')">
                          <i class="uil-bolt-alt"></i> {{ $t('general.add_rule') }}
                        </button>
                      </li>
                    </div>
                    <div class="uk-card-footer float-right pb-0 pr-0">
                      <button class="uk-button uk-button-outline small mr-2" type="button" @click="switcherChange(0)">
                        <i class="icon-feather-arrow-left"></i>{{ $t('general.previous') }}
                      </button>
                      <button :disabled="form.rules.length < 1" class="uk-button uk-button-primary small" type="button"
                              @click="saveForm()">
                        <i class="icon-feather-arrow-right"></i> {{ this.$t('general.save') }}
                      </button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <default-loading v-if="form_loading"></default-loading>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import store from "@/core/services";
import module, {
  BASE_URL,
  MODULE_NAME,
  ERROR,
  ITEMS,
  GET_ITEMS,
  DELETE_ITEM,
  LOADING,
  CREATE_ITEM,
  GET_ITEM,
  UPDATE_ITEM,
  UPDATE_ITEM_PUT
} from "@/core/services/store/assignment.module";
import position_module, {
  BASE_URL as POSITION_BASE_URL,
  GET_ITEMS as GET_POSITIONS,
  ITEMS as POSITIONS,
  MODULE_NAME as POSITION_MODULE,
} from "@/core/services/store/position.module";

import title_module, {
  BASE_URL as TITLE_BASE_URL,
  GET_ITEMS as GET_TITLES,
  ITEMS as TITLES,
  MODULE_NAME as TITLE_MODULE,
} from "@/core/services/store/title.module";

import region_module, {
  BASE_URL as REGION_BASE_URL,
  GET_ITEMS as GET_REGIONS,
  ITEMS as REGIONS,
  MODULE_NAME as REGION_MODULE,
} from "@/core/services/store/region.module";

import department_module, {
  BASE_URL as DEPARTMENT_BASE_URL,
  GET_ITEMS as GET_DEPARTMENTS,
  ITEMS as DEPARTMENTS,
  MODULE_NAME as DEPARTMENT_MODULE,
} from "@/core/services/store/department.module";

import branch_module, {
  BASE_URL as BRANCH_BASE_URL,
  GET_ITEMS as GET_BRANCHS,
  ITEMS as BRANCHS,
  MODULE_NAME as BRANCH_MODULE,
} from "@/core/services/store/branch.module";
import Pagination from "@/assets/components/Pagination";

const _POSITION_MODULE = POSITION_MODULE;
const _TITLE_MODULE = TITLE_MODULE;
const _REGION_MODULE = REGION_MODULE;
const _DEPARTMENT_MODULE = DEPARTMENT_MODULE;
const _BRANCH_MODULE = BRANCH_MODULE;
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import CompanyBreadcrumb from "@/view/company/components/breadcrumb/CompanyBreadcrumb";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput";
import AppModal from "@/view/components/ui/AppModal";
import SearchInput from "@/view/components/inputs/SearchInput";
import SortDropdown from "@/view/components/dropdown/SortDropdown";

export default {
  name: "addUpdateAutoAssignments",
  components: {
    Pagination,
    DefaultLoading,
    CompanyBreadcrumb,
    MultipleSelectInput,
    AppModal,
    SearchInput,
    SortDropdown
  },
  data() {
    return {
      form_loading: !!this.$route.params.id,
      showAssignmentModal: false,
      showRulesModal: false,
      selectedAssignmentName: '',
      selectedRuleIndex: 0,
      selectedOperator: 'and',
      selectedAssignmentItems: [],
      selectedRuleItems: [],
      selectedItemName: '',
      cover_image: null,
      savedAssignments: [],
      errorMessages: [],
      pagination: null,
      activeItem: null,
      successMessage: null,
      company_id: null,
      page: 1,
      per_page: 10,
      filter: {
        assignmentSearch: null,
        ruleSearch: null,
        search: null,
        sort: "desc",
        order_by: "created_at",
      },
      form: {
        name: '',
        assignment_id: null,
        rules: [],
      },
      selectedEvent: false,
      selectedRule: null,
      ruleTypeEvents: [
        { id: 1, name: this.$t('general.when_new_user_added'), ruleable_type: 'newUser', ruleable_operator: 'and' }],
      defaultRuleTypeStatus: [
        { id: 2, name: this.$t('general.their_position'), ruleable_type: 'position' },
        { id: 3, name: this.$t('general.their_job_title'), ruleable_type: 'title' },
        { id: 4, name: this.$t('general.gm_region'), ruleable_type: 'region' },
        { id: 5, name: this.$t('general.their_department'), ruleable_type: 'department' },
        { id: 6, name: this.$t('general.branch_store_distributor'), ruleable_type: 'branch' }
      ],
      ruleTypeStatus: [
        { id: 2, name: this.$t('general.their_position'), ruleable_type: 'position' },
        { id: 3, name: this.$t('general.their_job_title'), ruleable_type: 'title' },
        { id: 4, name: this.$t('general.gm_region'), ruleable_type: 'region' },
        { id: 5, name: this.$t('general.their_department'), ruleable_type: 'department' },
        { id: 6, name: this.$t('general.branch_store_distributor'), ruleable_type: 'branch' }
      ],
      ruleItems: [],
      paginationRule: null
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(MODULE_NAME, module);
    registerStoreModule(_POSITION_MODULE, position_module);
    registerStoreModule(_TITLE_MODULE, title_module);
    registerStoreModule(_REGION_MODULE, region_module);
    registerStoreModule(_DEPARTMENT_MODULE, department_module);
    registerStoreModule(_BRANCH_MODULE, branch_module);
  },
  computed: {
    isEditMode() {
      return !!this.$route.params.id;
    },
    breadcrumbItems() {
      return [
        { name: this.$t('general.auto_assignments'), route: { name: 'company.assignments.auto' } },
        { name: this.isEditMode ? this.$t('general.edit_auto_assignment') : this.$t('general.new_auto_assignment') },
      ];
    },
    operatorOptions() {
      return [
        { id: 'and', name: this.$t('general.and') },
        { id: 'or', name: this.$t('general.or') },
      ];
    },
    assignmentSortOptions() {
      return [
        { key: 'name-asc', sort: 'name', order: 'asc', label: this.$t('sorting.a_z') },
        { key: 'name-desc', sort: 'name', order: 'desc', label: this.$t('sorting.z_a') },
        { key: 'created_at-asc', sort: 'created_at', order: 'asc', label: this.$t('sorting.created_at_asc') },
        { key: 'created_at-desc', sort: 'created_at', order: 'desc', label: this.$t('sorting.created_at_desc') },
      ];
    },
    userInfo: {
      get: function () {
        return JSON.parse(this.secureLocalStorage("user"));
      },
      set: function (newValue) {
      },
    },
    branchs: {
      get() {
        return store.getters[BRANCH_MODULE + "/" + BRANCHS];
      },
      set(value) {
      },
    },
    departments: {
      get() {
        return store.getters[DEPARTMENT_MODULE + "/" + DEPARTMENTS];
      },
      set(value) {
      },
    },
    regions: {
      get() {
        return store.getters[REGION_MODULE + "/" + REGIONS];
      },
      set(value) {
      },
    },
    titles: {
      get() {
        return store.getters[TITLE_MODULE + "/" + TITLES];
      },
      set(value) {
      },
    },
    positions: {
      get() {
        return store.getters[POSITION_MODULE + "/" + POSITIONS];
      },
      set(value) {
      },
    },
    items: {
      get() {
        return store.getters[MODULE_NAME + "/" + ITEMS];
      },
      set(value) {
      },
    },
    formattedItem() {
      let results = [];
      if (this.items === null || !this.items || this.items.length === 0) return [];
      this.pagination = this.items;
      this.items.data.forEach((currentItem) => {
        results.push({
          id: currentItem.id,
          name: currentItem.name,
          hasAssigned: currentItem.users_count,
          cover_image_link: currentItem.cover_image_link,
          description: currentItem.description ? currentItem.description : "-",
          order_number: currentItem.repeatable_main_item
              ? this.$t("general.main_content_assignment")
              : currentItem.order_number + ". " + this.$t("general.repeated_assignment"),
          repeatable:
              currentItem.repeatable_main_item || currentItem.repeatable
                  ? true
                  : false,
          has_gift: currentItem.has_gift
              ? this.$t("general.yes")
              : this.$t("general.no"),
          created_at: currentItem.created_at
              ? moment(currentItem.created_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
          start_end:
              currentItem.start_date && currentItem.end_date
                  ? moment(currentItem.start_date).format("DD-MM-YYYY") +
                  " / " +
                  moment(currentItem.end_date).format("DD-MM-YYYY")
                  : "-",
        });
      });

      return results;
    },
    error: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
  },
  methods: {
    deleteRule(index) {
      this.form.rules.splice(index, 1);
    },
    openRuleModal(type, index = 0, event = 'addRule') {
      this.filter.ruleSearch = null;
      this.selectedRuleIndex = index;
      this.page = 1;
      this.selectedRule = this.form.rules[index];
      if (type === 'ruleTypeStatus') {
        this.ruleTypeStatus = [...this.defaultRuleTypeStatus];
        this.selectedEvent = false;
        if (event === 'editRule') {
          this.form['rules'][index].ruleable_id.forEach((ruleId, ruleIndex) => {
            this.selectedRuleItems.push({ name: this.form['rules'][index].ruleable_names[ruleIndex], id: ruleId });
          });
          let spliceIndex = null
          this.form['rules'].forEach((defaultRule, defaultRuleIndex) => {
            this.ruleTypeStatus.forEach((selectedRule, selectedRuleIndex) => {
              if (defaultRule.ruleable_type === selectedRule.ruleable_type && this.form['rules'][index].ruleable_type !== selectedRule.ruleable_type) {
                spliceIndex = selectedRuleIndex;
                this.ruleTypeStatus.splice(spliceIndex, 1);
              }
            })
          })
          this.changeOption();
        } else if (event === 'addRule') {
          let spliceIndex = null
          this.form.rules.forEach((defaultRule, defaultRuleIndex) => {
            this.ruleTypeStatus.forEach((selectedRule, selectedRuleIndex) => {
              if (defaultRule.ruleable_type === selectedRule.ruleable_type) {
                spliceIndex = selectedRuleIndex;
                this.ruleTypeStatus.splice(spliceIndex, 1);
              }
            })
          })
        }
      } else if (type === 'ruleTypeEvents') {
        this.selectedEvent = true
      }

      this.showRulesModal = true;
    },
    removeRuleItem(item) {
      this.selectedRuleItems.every((data, index) => {
        if (data.id === item.id) {
          this.selectedRuleItems.splice(index, 1)
          return false
        } else {
          return true;
        }
      })
    },
    addRuleItem(item) {
      this.selectedRuleItems.push({ name: item.name, id: item.id });
    },
    changeOption(event = null) {
      if (event === 'change')
        this.selectedRuleItems = []
      if (this.selectedRule['ruleable_type'] === 'position') {
        this.paginationRule = this.positions;
        this.ruleItems = this.positions.data;
      } else if (this.selectedRule['ruleable_type'] === 'title') {
        this.paginationRule = this.titles;
        this.ruleItems = this.titles.data;
      } else if (this.selectedRule['ruleable_type'] === 'region') {
        this.paginationRule = this.regions;
        this.ruleItems = this.regions.data;
      } else if (this.selectedRule['ruleable_type'] === 'department') {
        this.paginationRule = this.departments;
        this.ruleItems = this.departments.data;
      } else if (this.selectedRule['ruleable_type'] === 'branch') {
        this.paginationRule = this.branchs;
        this.ruleItems = this.branchs.data;
      }
    },
    getBranchs() {
      this.$store.dispatch(BRANCH_MODULE + "/" + GET_BRANCHS, {
        url: BRANCH_BASE_URL,
        filters: {
          name: this.filter.ruleSearch,
          company_id: this.company_id,
          per_page: this.per_page,
          page: this.page
        },
      }).then((data) => {
        this.paginationRule = data;
        this.ruleItems = data.data;
      });
    },
    getDepartments() {
      this.$store.dispatch(DEPARTMENT_MODULE + "/" + GET_DEPARTMENTS, {
        url: DEPARTMENT_BASE_URL,
        filters: {
          name: this.filter.ruleSearch,
          company_id: this.company_id,
          per_page: this.per_page,
          page: this.page
        },
      }).then((data) => {
        this.paginationRule = data;
        this.ruleItems = data.data;
      });
    },
    getRegions() {
      this.$store.dispatch(REGION_MODULE + "/" + GET_REGIONS, {
        url: REGION_BASE_URL,
        filters: {
          name: this.filter.ruleSearch,
          company_id: this.company_id,
          per_page: this.per_page,
          page: this.page
        },
      }).then((data) => {
        this.paginationRule = data;
        this.ruleItems = data.data;
      });
    },
    getTitles() {
      this.$store.dispatch(TITLE_MODULE + "/" + GET_TITLES, {
        url: TITLE_BASE_URL,
        filters: {
          name: this.filter.ruleSearch,
          company_id: this.company_id,
          per_page: this.per_page,
          page: this.page
        },
      }).then((data) => {
        this.paginationRule = data;
        this.ruleItems = data.data;
      });
    },
    getPositions() {
      this.$store.dispatch(POSITION_MODULE + "/" + GET_POSITIONS, {
        url: POSITION_BASE_URL,
        filters: {
          name: this.filter.ruleSearch,
          company_id: this.company_id,
          per_page: this.per_page,
          page: this.page,
        },
      }).then((data) => {
        this.paginationRule = data;
        this.ruleItems = data.data;
      });
    },
    saveForm() {
      this.form.rules.splice(0, 1);
      if (this.isEditMode) {
        store.dispatch(MODULE_NAME + "/" + UPDATE_ITEM_PUT, {
          url: 'api/automatic-assignments/' + this.$route.params.id + '?status_id=true',
          contents: this.form,
        }).then(() => {
          if (!this.error) {
            this.successMessage = this.$t("general.successfully_created");
            this.$router.push({ name: "company.assignments.auto" });
          } else this.errorMessages.push(this.error);
        });
      } else {
        store.dispatch(MODULE_NAME + "/" + CREATE_ITEM, {
          url: 'api/automatic-assignments?status_id=true',
          contents: this.form,
        }).then(() => {
          if (!this.error) {
            this.successMessage = this.$t("general.successfully_created");
            this.$router.push({ name: "company.assignments.auto" });
          } else this.errorMessages.push(this.error);
        });
      }
    },
    validateAndSwitch(index) {
      this.switcherChange(index)
    },
    switcherChange(index) {
      UIkit.switcher($("#uk-switcher-tab")[0]).show(index);
    },
    saveRule() {
      let ids = [];
      let names = [];
      this.selectedRuleItems.forEach((data) => {
        ids.push(data.id)
        names.push(data.name)
      })
      if (this.form.rules.length === this.selectedRuleIndex) {
        this.form.rules.push({
          name: this.selectedRule['name'],
          ruleable_id: ids,
          ruleable_type: this.selectedRule['ruleable_type'],
          ruleable_operator: this.selectedOperator ?? 'and',
          ruleable_names: names
        });
      } else {
        this.form.rules[this.selectedRuleIndex].name = this.selectedRule['name'];
        this.form.rules[this.selectedRuleIndex].ruleable_id = ids,
            this.form.rules[this.selectedRuleIndex].ruleable_type = this.selectedRule['ruleable_type'];
        this.form.rules[this.selectedRuleIndex].ruleable_operator = this.selectedOperator ?? 'and'
        this.form.rules[this.selectedRuleIndex].ruleable_names = names
      }
      this.selectedRule = [];
      this.selectedRuleItems = [];
      this.showRulesModal = false;
    },
    handleSortSelected({ sort, order }) {
      this.page = 1;
      this.filter.order_by = sort;
      this.filter.sort = order;
      this.getAssignmentResult();
    },
    setPage(page = null, event = null) {
      page ? this.page = page : this.page = 1;
      if (event === 'rules' || !event) {
        if (this.selectedRule['ruleable_type'] === 'position') {
          this.getPositions();
        } else if (this.selectedRule['ruleable_type'] === 'title') {
          this.getTitles();
        } else if (this.selectedRule['ruleable_type'] === 'region') {
          this.getRegions();
        } else if (this.selectedRule['ruleable_type'] === 'department') {
          this.getDepartments();
        } else if (this.selectedRule['ruleable_type'] === 'branch') {
          this.getBranchs();
        }
      } else if (event === 'assignment') {
        this.getAssignmentResult();
      }
    },
    addAssignment(item) {
      this.selectedAssignmentItems = []
      this.selectedItemName = item.name
      this.selectedAssignmentItems.push(item.id)
    },
    removeAssignment(item) {
      this.selectedAssignmentItems.every((data, index) => {
        if (data === item.id) {
          this.selectedAssignmentItems.splice(index, 1)
          return false
        } else {
          return true;
        }
      })
    },
    saveAssignment() {
      this.form.assignment_id = this.selectedAssignmentItems[0];
      this.selectedAssignmentName = this.selectedItemName;
      this.showAssignmentModal = false;
    },
    getAssignmentResult() {
      this.$store.dispatch(MODULE_NAME + "/" + GET_ITEMS, {
        url: BASE_URL,
        filters: {
          search: this.filter.assignmentSearch,
          page: this.page,
          per_page: this.per_page,
          sort: this.filter.sort,
          order_by: this.filter.order_by,
          with_expired: false,
          status_id: true,
        },
      });
    },
    processFile(event) {
      this.cover_image = event.target.files[0];
      let blob = URL.createObjectURL(this.cover_image);
      let imageHolder = $(".logoarea");
      imageHolder.attr("src", blob);
    },
    inputClick() {
      $("#cover_photo_input").click();
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
    getAutoAssignmentResult() {
      this.$store.dispatch(MODULE_NAME + "/" + GET_ITEM, {
        url: 'api/automatic-assignments' + "/" + this.$route.params.id,
      }).then((autoItem) => {

        this.form_loading = false;
        this.form.assignment_id = autoItem.data.assignable_id;
        this.form.name = autoItem.data.name;
        this.selectedAssignmentItems.push(autoItem.data.assignable_id);
        this.selectedAssignmentName = autoItem.data.assignable.full_name;
        let fixedData = [];
        autoItem.data.automatic_assignment_rules.forEach((rule, index) => {
          fixedData = this.setArray(fixedData, rule);
        })
        fixedData.unshift(this.ruleTypeEvents[0]);
        this.form.rules = fixedData;
      });
    },
    setArray(event, rule) {
      let isType = false;
      event.forEach((data) => {
        if (data.ruleable_type === rule.ruleable_type)
          isType = true;
      })
      if (isType) {
        event[event.length - 1]['ruleable_id'].push(rule.ruleable_id);
        event[event.length - 1]['ruleable_names'].push(rule.ruleable?.name);
      } else {
        event[event.length] = {
          'ruleable_operator': rule.ruleable_operator,
          'ruleable_type': rule.ruleable_type,
          'ruleable_id': [],
          'ruleable_names': []
        }
        this.defaultRuleTypeStatus.every((ruleType) => {
          if (ruleType.ruleable_type === rule.ruleable_type) {
            event[event.length - 1]['name'] = ruleType.name
            return false
          } else {
            return true
          }
        })
        event[event.length - 1]['ruleable_id'].push(rule.ruleable_id);
        event[event.length - 1]['ruleable_names'].push(rule.ruleable?.name);
      }
      return event;
    }
  },
  mounted() {
    this.company_id = this.userInfo.company_id;
    this.getAssignmentResult();
    this.getPositions();
    this.getTitles();
    this.getRegions();
    this.getDepartments();
    this.getBranchs();
    if (this.isEditMode) {
      this.getAutoAssignmentResult();
    }
  },
  watch: {
    "filter.ruleSearch": function (val) {
      this.debouncedFilterRuleSearch();
    },
    "filter.assignmentSearch": function (val) {
      this.debouncedFilterAssignmentSearch();
    },
    successMessage: function (val) {
      this.debouncedResetValues();
    },
    errorMessages: function (val) {
      this.debouncedResetValues();
    },
  },
  created: function () {
    this.debouncedFilterRuleSearch = _.debounce(this.setPage, 500);
    this.debouncedFilterAssignmentSearch = _.debounce(this.getAssignmentResult, 500);
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
  },

};
</script>
<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.dragBox input[type="file"] {
  position: absolute;
  height: 100%;
  width: 100%;
  opacity: 0;
  top: 0;
  left: 0;
}

.dragBox {
  width: auto;
  padding: 0 10px;
  height: 100px;
  margin: 0 auto;
  position: relative;
  text-align: center;
  font-weight: bold;
  line-height: 95px;
  color: #999;
  border: 2px dashed #ccc;
  display: inline-block;
  transition: transform 0.3s;
}

.uploadOuter strong {
  padding: 0 10px;
}

.uploadOuter {
  text-align: center;
  padding: 20px;
}
</style>

<style>
/* ── Base (desktop) ── */
.add-update-auto-page {
  min-width: 0;
}

.add-update-auto-page .card {
  padding: 16px 20px;
}

.add-update-auto-page .card .card-body {
  padding: 24px;
}

.header-a {
  cursor: default;
  pointer-events: none;
}

.bootstrap-select.open .dropdown-menu {
  opacity: 1 !important;
  pointer-events: all !important;
  visibility: visible !important;
}

.inner {
  opacity: 1 !important;
  visibility: visible !important;
}

/* Rule row - desktop */
.add-update-auto-page .rule-row {
  background-color: #f8f8f8;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

.add-update-auto-page .rule-row__label {
  text-align: left;
  width: 10%;
  flex-shrink: 0;
}

.add-update-auto-page .rule-row__values {
  width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.add-update-auto-page .rule-row__actions {
  text-align: end;
  width: 10%;
  flex-shrink: 0;
  white-space: nowrap;
}

/* Modal toolbar - search + sort */
.modal-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Multiselect dropdown - compact items */
.add-update-auto-page .multiselect__option {
  padding: 8px 12px !important;
  min-height: 0 !important;
  line-height: 1.4 !important;
}

.add-update-auto-page .multiselect__option:after {
  display: none !important;
}

/* Operator dropdown - remove form-group spacing */
.add-update-auto-page .rules_list > ul > li > .form-group {
  margin-bottom: 0;
}

/* Rules modal body - prevent x-scroll */
.rules-modal-body {
  overflow-x: hidden;
}

/* Multiselect dropdown inside modal - prevent clipping */
.rules-modal-body .multiselect__content-wrapper {
  z-index: 10;
}

/* ── Mobile: < 960px ── */
@media (max-width: 959px) {
  .add-update-auto-page {
    padding: 0 0 24px;
  }

  /* Page header */
  .add-update-auto-page .section-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .add-update-auto-page .section-header-left h2 {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.4;
  }

  .add-update-auto-page .section-header-left h2 span {
    padding: 0;
  }

  /* Stepper tabs */
  .add-update-auto-page .stepper-buttons a {
    padding: 12px 8px !important;
    font-size: 13px;
  }

  .add-update-auto-page .stepper-buttons i {
    display: none;
  }

  /* Card */
  .add-update-auto-page .card {
    padding: 12px 14px;
  }

  .add-update-auto-page .card .card-body {
    padding: 16px 12px;
  }

  /* Form: stack label + input vertically */
  .add-update-auto-page .form-group.row > [class*="col-md-"],
  .add-update-auto-page .form-group.row > [class*="col-xl-"] {
    flex: 0 0 100%;
    max-width: 100%;
    padding-right: 0;
    padding-left: 0;
  }

  .add-update-auto-page .col-form-label {
    display: block;
    margin-bottom: 8px;
    padding: 0;
    font-size: 14px;
    font-weight: 500;
  }

  .add-update-auto-page .form-control {
    min-height: 48px;
    height: auto;
    padding: 12px 16px;
    font-size: 16px;
    line-height: 1.4;
  }

  .add-update-auto-page .col-xl-10 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  /* Assignment select button */
  .add-update-auto-page .btn-default.btn-icon-label {
    width: 100%;
    min-height: 48px;
    margin-top: 8px;
    font-size: 16px;
    text-align: center;
  }

  /* Footer buttons */
  .add-update-auto-page .uk-card-footer {
    float: none !important;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px 0 !important;
  }

  .add-update-auto-page .uk-card-footer .uk-button {
    width: 100%;
    min-height: 48px;
    font-size: 16px;
    line-height: 1.4;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  /* Rule rows */
  .add-update-auto-page .rule-row {
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px !important;
  }

  .add-update-auto-page .rule-row__label {
    width: 100%;
    font-size: 14px;
  }

  .add-update-auto-page .rule-row__values {
    width: 100%;
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    font-size: 13px;
    line-height: 1.5;
  }

  .add-update-auto-page .rule-row__actions {
    width: 100%;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }

  .add-update-auto-page .rule-row__actions .uk-button {
    min-width: 44px;
    min-height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  /* Rule operator select */
  .add-update-auto-page .rules_list li select {
    min-height: 44px;
    font-size: 16px;
    width: 100%;
  }

  /* Add rule button */
  .add-update-auto-page .uk-button-small.w-100 {
    min-height: 48px;
    font-size: 15px;
  }

  /* Rules container spacing */
  .add-update-auto-page .mb-2.mx-2.px-2 {
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  /* First rule event row */
  .add-update-auto-page .rules_list > .w-100.d-flex {
    flex-direction: row;
    gap: 8px;
    padding: 12px !important;
  }

  /* Lead text */
  .add-update-auto-page .lead {
    font-size: 15px;
  }
}

/* AppModal fullscreen + content on mobile */
@media (max-width: 959px) {
  /* Fullscreen modal */
  .add-update-auto-page .app-modal-overlay {
    padding: 0 !important;
    align-items: stretch !important;
    justify-content: stretch !important;
  }

  .add-update-auto-page .app-modal {
    width: 100% !important;
    max-width: 100% !important;
    height: 100vh !important;
    max-height: 100vh !important;
    border-radius: 0 !important;
  }

  .add-update-auto-page .app-modal .app-modal-header {
    border-radius: 0 !important;
  }

  .add-update-auto-page .app-modal .app-modal-body {
    flex: 1 !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    min-height: 0 !important;
  }

  /* Footer buttons - MD guidelines: min-height 48px, font 16px, radius 10-12px */
  .add-update-auto-page .app-modal-footer {
    padding: 16px !important;
    gap: 8px !important;
  }

  .add-update-auto-page .app-modal-footer .btn {
    min-height: 48px;
    font-size: 16px;
    border-radius: 10px;
    padding: 12px 24px;
    flex: 1;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  /* Modal toolbar: search full-width */
  .modal-toolbar {
    width: 100%;
  }

  .modal-toolbar .search-input-component {
    flex: 1;
    min-width: 0;
  }

  /* Modal tables */
  .app-modal .table th,
  .app-modal .table td {
    padding: 10px 8px;
    font-size: 14px;
  }

  .app-modal .table .actions {
    margin-left: 0 !important;
  }

  .app-modal .table .actions .btn {
    min-width: 44px;
    min-height: 44px;
    padding: 8px 12px;
    border-radius: 10px;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  /* Rules modal: multiselect */
  .rules-modal-body .custom-multiselect {
    min-height: 48px;
  }

  /* Rules modal: info alert */
  .app-modal .uk-alert-access {
    flex-direction: column;
    text-align: center;
  }

  .app-modal .uk-alert-access i {
    margin-right: 0 !important;
    margin-bottom: 8px;
  }
}

/* ── Small mobile: < 480px ── */
@media (max-width: 479px) {
  .add-update-auto-page .card {
    padding: 8px 10px;
  }

  .add-update-auto-page .card .card-body {
    padding: 12px 8px;
  }

  .add-update-auto-page .stepper-buttons a {
    padding: 10px 6px !important;
    font-size: 12px;
  }
}

/* ── Hover / Touch ── */
@media (hover: hover) and (pointer: fine) {
  .add-update-auto-page .uk-button-primary:hover:not(:disabled) {
    opacity: 0.92;
  }
}

@media (hover: none) {
  .add-update-auto-page .uk-button:hover {
    background-color: transparent;
  }
}

@media (prefers-reduced-motion: reduce) {
  .add-update-auto-page .uk-button:active,
  .add-update-auto-page .btn:active {
    transform: none;
  }
}
</style>
